<template>
  <div>
    <wg-modal
      :width="windowWidth > 700 ? '700px' : '90%'"
      v-if="showWcDialog"
      @closeModal="showWcDialog = !showWcDialog"
    >
    <div class="com-anm22-app-text-l" slot="header">
      {{ $anm22.strLang(lang, 'Edit work cost', 'Modifica categoria di costo') }}
    </div>
    <div class="wg-row" slot="body">
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
            type="text"
            v-model="wcSelected.name"
          >
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Area', 'Area') }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select class="com-anm22-app-select" v-model="wcSelected.area">
            <option disabled value>{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
            <option 
                v-for="(wca,key,index) in $anm22.tableClasses.worldWorkCostArea().getAll()"
                :key="'wca-'+index"
                :value="key">
              {{ wca[lang] }}
            </option>
          </select>
        </div>
      </div>
      <div style="height: 15px" class="vertical-height-div"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Weekday price ', 'Costo giorno feriale ') + '(EUR)' }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.weekDayPrice"
          >
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Holiday price ', 'Costo giorno festivo ') + '(EUR)' }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.holidayPrice"
          >
        </div>
      </div>
      <div style="height: 15px" class="vertical-height-div"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Night price ', 'Costo notturna ') + '(EUR)' }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.nightPrice"
          >
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row" style="align-items:center;">
            <div class="com-anm22-app-text-m">
              {{ 
                $anm22.strLang(lang, 'Workday of less than ', 'Costo giornata con meno di ') 
              }}
            </div>
            <input
              class="com-anm22-app-input-text"
              style="width:50px;margin:0 5px;"
              type="number"
              v-model="wcSelected.hoursCap"
            >
            <div class="com-anm22-app-text-m">
              {{ 
                $anm22.strLang(lang, 'hours of work ', 'ore di lavoro ') + '(EUR)' 
              }}
            </div>
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.dayWithLessThanCapHoursPrice"
          >
        </div>
      </div>
      <div style="height: 15px" class="vertical-height-div"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Included hours', 'Ore comprese') }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.includedHours"
          >
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 
              'Price per not included hours (Weekday)(EUR/h)', 
              'Costo ore non incluse (Giorni feriali) (EUR/h)'
            ) }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.pricePerNotIncludedHoursWeekday"
          >
        </div>
      </div>
      <div style="height: 15px" class="vertical-height-div"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 
              'Price per not included hours (Holiday)(EUR/h)', 
              'Costo ore non incluse (Giorni festivi) (EUR/h)'
            ) }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.pricePerNotIncludedHoursHoliday"
          >
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 
              'Price per not included hours (Night)(EUR/h)', 
              'Costo ore non incluse (Notturna) (EUR/h)'
            ) }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.pricePerNotIncludedHoursNight"
          >
        </div>
      </div>
      <div style="height: 15px" class="vertical-height-div"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 
              'Daily Allowance (EUR/day)', 
              'Diaria (EUR/gg)'
            ) }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.dailyPay"
          >
        </div>
      </div>
      <div style="height: 20px" class="vertical-height-div"></div>
      <div class="wg-col wg-xs-12">
        <input
            type="button" 
            :value="$anm22.strLang(lang, 'Save', 'Salva')"
            @click="saveWorkCost"
        >
      </div>
    </div>
    </wg-modal>
    <h1 class="com-anm22-page-title">
      {{ pricing
      ? $anm22.strLang(lang, 'Edit pricing', 'Modifica condizioni economiche')
      : $anm22.strLang(lang, 'New pricing', 'Crea condizioni economiche') }}
    </h1>
    <template v-if="!loading">
      <template v-if="pricing">
        <!-- Gestione categorie di costo -->
        <div
          class="com-anm22-app-text-xl"
        >{{ $anm22.strLang(lang, 'Cost categories', 'Categorie di costo') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div
          v-if="costCategories.length === 0"
          class="com-anm22-app-text-l"
        >{{ $anm22.strLang(lang, 'No cost categories', 'Nessuna categoria di costo') }}</div>
        <template v-else>
          <div
            v-for="(wc, index) in costCategories"
            :key="'wc'+index"
            class="wg-row"
            style="margin:5px 0;font-size:14px;align-items:center;"
          >
            <div
              :class="['work-pricing-cost-category-selected', (pricing && wc.idWorldWorkCost === pricing.costCategory) ? 'selected' : '']"
              @click="toggleWorkCost(wc.idWorldWorkCost)"
            >✓</div>
            <div class="display-flex" style="align-items:center;" >
              <div class="com-anm22-app-text-m">{{ wc.name }}</div>
              <img
                v-if="!onlyView"
                class="com-anm22-app-img-xs"
                style="margin-left:3px;cursor:pointer;"
                :src="$anm22.icons.getWorldIcon('edit')"
                :title="$anm22.strLang(lang, 'Edit', 'Modifica categoria di costo')"
                @click="editWorkCost(wc)"
              >
            </div>
          </div>
        </template>
        <template v-if="!onlyView">
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- Aggiunta di una categoria di costo -->
          <div class="wg-row">
            <input 
              type="button" 
              class="small"
              :value="$anm22.strLang(lang, '+ Add', '+ Aggiungi')"
              @click="newWorkCost">
          </div>
        </template>
        <div class="vertical-height-div" style="height:30px;"></div>
        <!-- Gestione tipologie di spesa -->
        <div
          class="com-anm22-app-text-xl"
        >{{ $anm22.strLang(lang, 'Expense types', 'Tipologie di spesa') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div
          v-if="outgoCategories.length === 0"
          class="com-anm22-app-text-l"
        >{{ $anm22.strLang(lang, 'No outgo categories', 'Nessuna tipologia di spesa') }}</div>
        <template v-else>
          <div
            v-for="(oc, index) in outgoCategories"
            :key="'oc'+index"
            class="wg-row"
            style="margin:5px 0;font-size:14px;height:20px;align-items:center;"
          >
            <!-- category image to-do -->
            <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
            <div
              :class="['work-pricing-category-diary', oc.selected ? 'selected' : '']"
              @click="toggleOutgoCategory(oc)"
            >✓</div>
            <template v-if="oc.selected">
              <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
              <div
                :class="['work-pricing-category-diary', oc.diary ? 'selected' : '']"
                @click="toggleOutgoCategoryDiary(oc)"
              >D</div>
            </template>
            <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
            <div
              class="com-anm22-app-text-m"
              :style="oc.deleted ? 'color:#b71c1c' : ''"
              :title="oc.deleted ? $anm22.strLang(lang, 'Type deleted', 'Tipologia cancellata') : ''"
            >{{ oc.name }}</div>
          </div>
        </template>
        <!-- Gestione pricing -->
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-xl"
          >{{ $anm22.strLang(lang, 'Night time', 'Orario notturno') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="wg-col wg-xs-3" style="padding:0 5px 0 0;">
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, 'Start hours', 'Ore inizio') }}</div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <input
              :disabled="onlyView"
              class="com-anm22-app-input-number"
              :placeholder="$anm22.strLang(lang, 'Hours', 'Ore')"
              type="number"
              min="0"
              max="23"
              step="1"
              v-model.number="pricing.nightTimeStartHours"
            >
          </div>
          <div class="wg-col wg-xs-3" style="padding:0 5px 0 0;">
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, 'Start minutes', 'Minuti inizio') }}</div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <input
              :disabled="onlyView"
              class="com-anm22-app-input-number"
              :placeholder="$anm22.strLang(lang, 'Minutes', 'Minuti')"
              type="number"
              min="0"
              max="59"
              step="1"
              v-model.number="pricing.nightTimeStartMinutes"
            >
          </div>
          <div class="wg-col wg-xs-3" style="padding:0 5px 0 0;">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'End hours', 'Ore fine') }}</div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <input
              :disabled="onlyView"
              class="com-anm22-app-input-number"
              :placeholder="$anm22.strLang(lang, 'Hours', 'Ore')"
              type="number"
              min="0"
              max="23"
              step="1"
              v-model.number="pricing.nightTimeEndHours"
            >
          </div>
          <div class="wg-col wg-xs-3" style="padding:0 5px 0 0;">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'End minutes', 'Ore fine') }}</div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <input
              :disabled="onlyView"
              class="com-anm22-app-input-number"
              :placeholder="$anm22.strLang(lang, 'Minutes', 'Minuti')"
              type="number"
              min="0"
              max="59"
              step="1"
              v-model.number="pricing.nightTimeEndMinutes"
            >
          </div>
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Holiday calendar', 'Calendario festivi') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.holidayCountry">
            <option disabled value>{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
            <!-- Set ristretto di paesi da poter scegliere -->
            <option value="it">{{ $anm22.tableClasses.worldCountry().getById('it')[lang] }}</option>
            <option value="sm">{{ $anm22.tableClasses.worldCountry().getById('sm')[lang] }}</option>
          </select>
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Cost per kilometer (EUR/km)', 'Costo chilometrico (EUR/km)') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input
            :disabled="onlyView"
            class="com-anm22-app-input-text"
            type="number"
            step="0.01"
            min="0"
            v-model="costPerKm"
          >
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Plant daily pay', 'Diaria impianto') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input
            :disabled="onlyView"
            class="com-anm22-app-input-text"
            type="number"
            step="0.01"
            min="0"
            v-model="dailyPay"
          >
        </div>
        <div class="vertical-height-div" style="height:40px;"></div>
        <div
          class="com-anm22-app-text-l"
          style="color:#999;font-weight:bold;text-transform:uppercase;"
        >{{ $anm22.strLang(lang, 'Payment mode', 'Modalità di pagamento') }}</div>
        <div class="vertical-height-div" style="height:15px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'Type', 'Tipologia') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.paymentModeType">
            <option disabled value="0">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
            <option
              v-for="(pm, key, index) in $anm22.tableClasses.worldPaymentModeType().getAll()"
              :key="'pm'+index"
              :value="key"
            >{{ pm[lang] }}</option>
          </select>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Support bank', 'Banca d\'appoggio') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input
            :disabled="onlyView"
            class="com-anm22-app-input-text"
            :placeholder="$anm22.strLang(lang, 'Support bank', 'Banca d\'appoggio')"
            type="text"
            v-model="pricing.paymentModeSupportBank"
          >
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Division of services and invoiced expenses', 'Divisione servizi e spese in fattura') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.servicesAndExpensesDivision">
            <option value="1">{{ $anm22.strLang(lang, 'Yes', 'Si') }}</option>
            <option value="0">{{ $anm22.strLang(lang, 'No', 'No') }}</option>
          </select>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Service deferment', 'Dilazione servizi') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.paymentModeServiceDeferment">
            <option disabled value="0">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
            <option
              v-for="(def, key, index) in $anm22.tableClasses.deferment().getAll()"
              :key="'def'+index"
              :value="key"
            >{{ def[lang] }}</option>
          </select>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Outgoes deferment', 'Dilazione spese') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.paymentModeOutgoesDeferment">
            <option disabled value="0">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
            <option
              v-for="(def, key, index) in $anm22.tableClasses.deferment().getAll()"
              :key="'def'+index"
              :value="key"
            >{{ def[lang] }}</option>
          </select>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Advance bills deferment', 'Dilazione fatture di anticipo') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.paymentModeBillsInAdvanceDeferment">
            <option disabled value="0">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
            <option
              v-for="(def, key, index) in $anm22.tableClasses.deferment().getAll()"
              :key="'def'+index"
              :value="key"
            >{{ def[lang] }}</option>
          </select>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Website for currency change', 'Sito di riferimento per cambi di valuta') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input
            :disabled="onlyView"
            class="com-anm22-app-input-text"
            :placeholder="'Url'"
            type="text"
            v-model="pricing.currencyChangeWebsite"
          >
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Surcharge for cash expenses (%)', 'Maggiorazione per spese in contanti (%)') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input
            :disabled="onlyView"
            class="com-anm22-app-input-text"
            :placeholder="$anm22.strLang(lang, 'Surcharge', 'Maggiorazione')"
            type="number"
            min="0"
            v-model="pricing.increaseForCashOutgoes"
          >
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Order confirmation email', 'Email per conferme d\'ordine') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input
            :disabled="onlyView"
            class="com-anm22-app-input-text"
            :placeholder="$anm22.strLang(lang, 'Order confirmation email', 'Email per conferme d\'ordine')"
            type="text"
            v-model="pricing.orderConfirmationSendingEmail"
          >
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Invoice sending email', 'Email per invio fatture') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input
            :disabled="onlyView"
            class="com-anm22-app-input-text"
            :placeholder="$anm22.strLang(lang, 'Invoice sending email', 'Email per invio fatture')"
            type="text"
            v-model="pricing.invoiceSendingEmail"
          >
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Preliminary invoice sending email', 'Email per invio prefatture') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input
            :disabled="onlyView"
            class="com-anm22-app-input-text"
            :placeholder="$anm22.strLang(lang, 'Invoice sending email', 'Email per invio fatture')"
            type="text"
            v-model="pricing.preliminaryInvoiceSendingEmail"
          >
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div v-if="!onlyView" class="wg-row">
          <input type="button" :value="$anm22.strLang(lang, 'Save', 'Salva')" @click="savePricing">
        </div>
      </template>
      <template v-else-if="!onlyView">
        <div class="wg-row">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'New pricing', 'Nuove condizioni')"
            @click="createNewPricing"
          >
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Import customer pricing', 'Importa condizioni cliente')"
            :style="!project.customers.length > 0 ? 'opacity:0.4;cursor:default;' : ''"
            @click="!project.customers.length > 0 ? copyCustomerPricing : ''"
          >
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    data: Object
  },
  data() {
    return {
      loading: false,
      // usato solo in fase di creazione in copia in caso di più di un customer per il progetto
      customerSelected: null,
      // Aggiunta/modifica work cost
      showWcDialog: false,
      wcSelected: null
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      offline: state => state.offline.isOffline,
      windowWidth: state => state.windowWidth
    }),
    project() {
      return this.$store.getters["projects/get"](
        this.data.project.idWorldProject
      );
    },
    userPermission() {
      return this.$store.getters["employments/getPermByProject"](this.project);
    },
    onlyView() {
      // Se è solo responsabile di progetto, con permessi alti, può solo vedere le condizioni economiche
      return this.userPermission > 3 && !!this.data.customerManager;
    },
    pricing() {
      return this.$store.getters["pricings/getByProject"](
        this.project.idWorldProject
      );
    },
    costCategories() {
      return this.$store.getters["workCosts/getByProject"](
        this.project.idWorldProject
      );
    },
    outgoCategories() {
      if (!this.loading) {
        return this.$store.getters["outgoCategories/getBySupplier"](
          this.pricing.supplier
        ).map(oc => {
          const assoc = this.$store.getters["outgoCategoryProjectAssocs/get"](
            oc.idWorldOutgoCategory + "-" + this.project.idWorldProject
          );
          if (assoc) {
            return {
              ...oc,
              selected: true,
              diary: assoc.diary,
              deleted: assoc.deleted
            };
          } else {
            return { ...oc, selected: false, diary: null, deleted: false };
          }
        });
      } else {
        return [];
      }
    },
    costPerKm: {
      get() {
        return this.pricing.costPerKm ? this.pricing.costPerKm.toFixed(2) : 0;
      },
      set(val) {
        this.pricing.costPerKm = val;
      }
    },
    dailyPay: {
      get() {
        return this.pricing.dailyPay ? this.pricing.dailyPay : 0;
      },
      set(val) {
        this.pricing.dailyPay = val;
      }
    }
  },
  methods: {
    savePricing() {
      if (!this.onlyView) {
        this.$http
          .post("link/pricing", {
            projectId: this.project.idWorldProject,
            pricing: this.pricing
          }, {
            withCredentials: true
          })
          .then(response => {
            this.$store.dispatch("pricings/update", {
              vlf: this.$vlf("pricings"),
              objs: [response.data.pricing]
            });
          })
          .catch(error => {});
      }
    },
    toggleWorkCost(wcId) {
      this.$http
        .post("link/selectWorkCost", {
          projectId: this.project.idWorldProject,
          workCostId: wcId
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data) {
            this.$store.dispatch("pricings/update", {
              vlf: this.$vlf("pricings"),
              objs: [response.data.pricing]
            });
          }
        });
    },
    editWorkCost(wc) {
      this.wcSelected = wc;
      this.showWcDialog = true;
    },
    newWorkCost(wc) {
      this.wcSelected = {};
      this.showWcDialog = true;
    },
    saveWorkCost() {
      this.$http
        .post('link/saveWorkCost', {
          projectId: this.project.idWorldProject,
          workCost: this.wcSelected
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("workCosts/update", {
            vlf: this.$vlf("workCosts"),
            objs: [response.data.workCost]
          })
          .then(() => {
            this.wcSelected = null;
            this.showWcDialog = false;
          })
        })
        .catch(e => console.log(e));
    },
    toggleOutgoCategory(oc) {
      this.$http
        .post("link/toggleOutgoCategory", {
          projectId: this.project.idWorldProject,
          categoryId: oc.idWorldOutgoCategory
        }, {
          withCredentials: true
        })
        .then(response => {
          //Selezione o deselezione
          if (oc.selected) {
            if (oc.deleted) {
              this.$store.dispatch("outgoCategories/delete", {
                vlf: this.$vlf("outgoCategories"),
                obj: oc
              });
            }
            this.$store.dispatch("outgoCategoryProjectAssocs/delete", {
              vlf: this.$vlf("outgoCategoryProjectAssocs"),
              obj: response.data.outgoCategoryProject
            });
          } else {
            this.$store.dispatch("outgoCategoryProjectAssocs/update", {
              vlf: this.$vlf("outgoCategoryProjectAssocs"),
              objs: [response.data.outgoCategoryProject]
            });
          }
        })
        .catch(error => {});
    },
    toggleOutgoCategoryDiary(oc) {
      this.$http
        .post("link/toggleOutgoCategoryDiary", {
          projectId: this.project.idWorldProject,
          categoryId: oc.idWorldOutgoCategory
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("outgoCategoryProjectAssocs/update", {
            vlf: this.$vlf("outgoCategoryProjectAssocs"),
            objs: [response.data.outgoCategoryProject]
          });
        })
        .catch(error => {});
    },
    /* Nel caso l'utente non abbia già il customer come cliente del suo empl, creo anche l'associazione */
    // setSupplierAccountable(obj) {
    //   this.$http
    //     .post("link/setSupplierAccountable", {
    //       projectId: this.project.idWorldProject,
    //       userId: obj.id
    //     })
    //     .then(response => {
    //       this.$store.dispatch("employments/update", {
    //         vlf: this.$vlf('employments'), objs: [response.data.employment]
    //       });
    //     })
    //     .catch(error => {});
    // },
    // removeSupplierAccountable(userId) {
    //   this.$http
    //     .post("project/removeSupplierAccountable", {
    //       projectId: this.project.idWorldProject,
    //       pricingId: this.pricing.idWorldWorkPricing
    //     })
    //     .then(response => {
    //       this.$store.dispatch("employments/update", {
    //         vlf: this.$vlf('employments'), objs: [response.data.employment]
    //       });
    //     })
    //     .catch(error => {});
    // },
    createNewPricing() {
      /**
       * Se c'è più di un cliente per il progetto devo far scegliere all'utente quale utilizzare
       */
      this.$http
        .post("link/newPricing", {
          projectId: this.project.idWorldProject
        }, {
          withCredentials: true
        })
        .then(response => {
          this.loadPage();
        })
        .catch(e => console.log(e));
    },
    copyCustomerPricing() {
      /**
       * Se c'è un solo cliente per il progetto allora copio direttamente, altrimenti è necessario integrare un
       * modale di scelta
       */
      this.$http
        .post("link/copyPricing", {
          projectId: this.project.idWorldProject,
          contact: this.project.customers[0]
        }, {
          withCredentials: true
        })
        .then(response => {
          this.loadPage();
        })
        .catch(e => console.log(e));
    },
    loadData() {
      Promise.all([
        this.$store.dispatch("pricings/load", this.$vlf("pricings")),
        this.$store.dispatch("workCosts/load", this.$vlf("workCosts")),
        this.$store.dispatch(
          "outgoCategories/load",
          this.$vlf("outgoCategories")
        ),
        this.$store.dispatch(
          "outgoCategoryProjectAssocs/load",
          this.$vlf("outgoCategoryProjectAssocs")
        )
      ]).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },
    loadPage() {
      this.$http
        .get("link/pricing?idProject=" + this.$route.params.id)
        .then(response => {
          Promise.all([
            this.$store.dispatch("pricings/update", {
              vlf: this.$vlf("pricings"),
              objs: [response.data.pricing],
              cleanFilters: [p => p.project === this.project.idWorldProject]
            }),
            this.$store.dispatch("workCosts/update", {
              vlf: this.$vlf("workCosts"),
              objs: response.data.workCosts,
              cleanFilters: [wc => wc.project === this.project.idWorldProject]
            }),
            this.$store.dispatch("outgoCategories/update", {
              vlf: this.$vlf("outgoCategories"),
              objs: response.data.outgoCategories
            }),
            this.$store.dispatch("outgoCategoryProjectAssocs/update", {
              vlf: this.$vlf("outgoCategoryProjectAssocs"),
              objs: response.data.outgoCategoryProjectAssocs,
              cleanFilters: [ocp => ocp.project === this.project.idWorldProject]
            })
          ]).then(() => {
            this.loading = false;
            this.$Progress.finish();
          });
        })
        .catch(error => {
          //Recupero dal db offline
        });
    }
  },
  created() {
    this.loading = true;
    this.loadData();
    this.loadPage();
  }
};
</script>

<style lang="scss" scoped>
</style>
